export const LABELS_RESOURCE_NAME = 'labels'
export const LABELS_PREFIX = 'MONITORING'

export type LabelMap = {
  id: string,
  label: string
}

export type Labels = {
  accessManager: {
    organizations: LabelMap[],
    environments: LabelMap[]
  }
  runtimeManager: {
    cloudhub: {
      applications: LabelMap[]
    },
    hybrid: {
      applications: LabelMap[],
      servers: LabelMap[],
      serverGroups: LabelMap[],
      clusters: LabelMap[]
    },
    runtimeFabric: {
      applications: LabelMap[],
      fabrics: LabelMap[]
    }
  },
  apiManager: {
    apis: LabelMap[],
    apiInstances: LabelMap[],
    policies: LabelMap[],
    clients: LabelMap[]
  }
}